import React, { Component } from 'react'
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import CurrencyFormat from 'react-currency-format';
import { Select } from '@rmwc/select';

import * as actionCreator from '../../../action/index';
import {const_var } from '../../../redux/reducers/reducer';

import EditPriceItem from '../../EditPriceItem/EditPriceItem';
import AnimButton from '../../Button/AnimButton';
import { Radio } from '@rmwc/radio';

class CupolaEditBox extends Component {
   constructor(props) {
      super(props);
   }
   state = {
      activeDrags: 0,
      deltaPosition: {
         x: 0, y: 0
      },
      controlledPosition: {
         x: 0, y: 0
      }
   };
   handleDrag = (e, ui) => {
      const {x, y} = this.state.deltaPosition;
      this.setState({
         deltaPosition: {
            x: x + ui.deltaX,
            y: y + ui.deltaY - 100,
         }
         });
      };
   onStart = () => { 
      this.setState({activeDrags: ++this.state.activeDrags});
   };
   onStop = () => {
      this.setState({activeDrags: --this.state.activeDrags});
   };
   
   onControlledDrag = (e, position) => {  
      const {x, y} = position;
      this.setState({controlledPosition: {x, y}});
   };
   
   onControlledDragStop = (e, position) => {   
      this.onControlledDrag(e, position);
      this.onStop();
   };
   componentDidUpdate(prevProps, prevState){
      let dweditbox = document.querySelector('.dw-show-edit-box-wrapper');
      let canvaswrapper = document.querySelector('.buildcanvas-section').offsetWidth - 340;
      let tOLeft = dweditbox.offsetLeft;                   
      if (tOLeft > canvaswrapper) {
         dweditbox.classList.add('outfromdom');
      } else {
         dweditbox.classList.remove('outfromdom');
      }  

      if(prevProps !== this.props) {
         const cupolaEditIcon = document.getElementById('cupola-edit-icon')?.getBoundingClientRect();
         const x = cupolaEditIcon?.left + 40;
         const y = cupolaEditIcon?.top - 50;
         this.setState({controlledPosition : {x: x, y: y }})
      }
   }

   render() {
      if(const_var.showCupolaEditBox==true) {
         document.querySelector('body').classList.add('active-dw-edit');
      } else {  
            document.querySelector('body').classList.remove('active-dw-edit');
      }

      const dragHandlers = {onStart: this.onStart, onStop: this.onStop};
      const {controlledPosition} = this.state;
      let uniqueId = const_var.cupolaUniqueId;
      const cupola_show = const_var.cupolas.find((cupola) => cupola.uniqueId === uniqueId);
      let findSelectedCupola = const_var.cupolaEntries.filter(cupola => cupola.uniqueId == uniqueId);
      let cupola = findSelectedCupola[0];

      return (
         <div  className={const_var.showCupolaEditBox==true ?'dw-show-edit-box-wrapper ':'dw-show-edit-box-wrapper  d-none'}>
            <div onClick={e=>this.props.hancleClickOutside()} className='dweditbox-overlay'></div>
            <Draggable
               position={controlledPosition} {...dragHandlers} handle=".handle" onDrag={this.onControlledDrag} 
               bounds="parent"
               className={'card-box'}
               >
               <div className='door-window-drag-inner cupola-drag-inner'>
                  <div className="handle">
                     <span>
                           <i className='icon-drag-ico'></i>
                     </span>
                  </div>
                  <div className="dw-show-edit-box-wrapper-top"> 
                     { cupola &&
                        <>
                           <div className='cupola-header-container'>
                              <div className='header-title'>
                                 Cupola {cupola?.cupolaName} {cupola ? cupola.dimension + "'": ''}
                              </div>
                           </div>
                           <div className='choose-size-text'>
                              Choose Size
                           </div>
                           <div>
                              {const_var.cupolasData !== undefined && Object.keys(const_var.cupolasData).length > 0 && cupola_show != undefined && cupola_show.userData &&
                                 <div className="radio-group">
                                    {
                                          const_var.cupolasData[cupola_show.userData.compType] && const_var.cupolasData[cupola_show.userData.compType].map((item) => {
                                          return (
                                             <div className='d-flex'>
                                                <div className='size-item'>
                                                   <Radio
                                                      value={item.id}
                                                      checked = {cupola_show.userData.cupolaTypeId == item.id}
                                                      onClick={e => {this.props.handleCupola(e.target.value,'update',uniqueId,cupola_show); this.props.const_var.cupolaUniqueId = uniqueId;}}
                                                   >
                                                      {item.structure+"'"}
                                                   </Radio>

                                                </div>
                                                {
                                                   cupola_show.userData.cupolaTypeId == item.id &&
                                                   <div className='ml-2'>
                                                      {((const_var.loginSession == true && const_var.post_data.building != undefined )) ?
                                                         <aside className="price-box">
                                                            <EditPriceItem  cupolaId={cupola ? cupola.uniqueId : 0} cupolaPrice="true" jsonObj={cupola ? cupola.cupola_price : 0} jsonObjKey="cupola_price" />
                                                         </aside>
                                                         :
                                                         <span className="price-box-type-2">
                                                            {const_var.hide_price_calculation != 1 && const_var.loginSession == false  &&
                                                               <CurrencyFormat value = {cupola ? cupola.cupola_price:0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                            }                                    
                                                         </span>
                                                      }
                                                   </div>
                                                }
                                             </div>
                                          )
                                       })
                                    }
                                 </div>
                              }
                           </div>
                        </>
                     }
                  </div>

                  <div className="dw-show-edit-box-bottom">
                     <button onClick={()=>this.props.handleCupola('','close')} className="btn btn-primary">Done</button>
                  </div>

               </div>
            </Draggable>
         </div>
      );
   }
}
const mapStateToProps = (state) => {
   return { ...state.reducer, ...state.eventReducer, ...state.priceUpdateReducer  }
}
export default connect(
   mapStateToProps,
   actionCreator
)(React.memo(CupolaEditBox));

